import queryString from 'query-string'
import generateActionFactory from 'utils/generateAction'

const generateAction = generateActionFactory('assessor/registration/')

const [
  LOAD_ASSESSOR,
  LOAD_ASSESSOR_SUCCESS,
  LOAD_ASSESSOR_FAIL
] = generateAction('LOAD_ASSESSOR')

// REDUCERS
const initialProfileState = {
  data: {},
  isLoading: false
}

export default function profile(state = initialProfileState, action) {
  switch (action.type) {
    case LOAD_ASSESSOR:
      return {
        ...state,
        isLoading: true
      }
    case LOAD_ASSESSOR_SUCCESS:
      return {
        ...state,
        data: action.result,
        isLoading: false
      }
    case LOAD_ASSESSOR_FAIL:
      return {
        ...state,
        isLoading: false
      }
    default:
      return state
  }
}

// ACTION CREATORS

export const loadAssessor = authorizationCode => ({
  types: [LOAD_ASSESSOR, LOAD_ASSESSOR_SUCCESS, LOAD_ASSESSOR_FAIL],
  promise: client =>
    client.get(
      'api/assessor-registrations/using-authorization-code?' +
        queryString.stringify({ authorizationCode })
    )
})


